export const initialState = {
  isAuthenticated: false,
  session: null,
  userAttributes: null,
  loading: true,
  errorMessage: null,
  newPasswordRequired: false,
  user: null,
  activePath: typeof window !== "undefined" ? window.location.pathname : "/",
  mfaRequired: false,
};

export const AuthReducer = (initialState, action) => {
  switch (action.type) {
    case "REQUEST_LOGIN":
      return {
        ...initialState,
        loading: true,
      };
    case "LOGIN_SUCCESS":
      return {
        ...initialState,
        loading: false,
        newPasswordRequired: false,
        mfaRequired: false,
        errorMessage: null,
      };
    case "LOGOUT":
      return {
        ...initialState,
        isAuthenticated: false,
        session: null,
        userAttributes: null,
        loading: false,
        newPasswordRequired: false,
        mfaRequired: false,
        user: null,
        activePath: "/",
      };

    case "LOGIN_ERROR":
      return {
        ...initialState,
        loading: false,
        errorMessage: action.error,
        newPasswordRequired: false,
        mfaRequired: false,
      };
    case "CHECK_SESSION": {
      return {
        ...initialState,
        isAuthenticated: action.isAuthenticated,
        session: action.session,
        loading: false,
      };
    }
    case "GET_USER_INFO_SUCCESS": {
      return {
        ...initialState,
        userAttributes: action.userAttributes,
        loading: false,
      };
    }
    case "GET_USER_INFO_ERROR": {
      return {
        ...initialState,
        loading: false,
        errorMessage: action.error,
      };
    }
    case "NEW_PASSWORD_REQUIRED": {
      return {
        ...initialState,
        newPasswordRequired: true,
        user: action.user,
        loading: false,
      };
    }
    case "CLEAR_ERROR": {
      return {
        ...initialState,
        errorMessage: null,
      };
    }
    case "NAVIGATE": {
      return {
        ...initialState,
        activePath: action.payload,
      };
    }
    case "MFA_REQUIRED":
      return {
        ...initialState,
        mfaRequired: true,
        user: action.user,
        loading: false,
      };
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
};
